<template>
  <header>
    <div class="breadcrumbs">
      <router-link :class="[$route.name?.includes('Summary') ? 'hide-on-mobile' : '']" :to="{ name: 'Home' }">Ticket Finder Home</router-link>
      <template v-for="(path, id) in breadcrumbs" :key="path">
        <img :class="[id === 0 && $route.name?.includes('Summary') ? 'hide-on-mobile' : '']" class="arrow" src="@/assets/icons/breadcrumbs-arrow.svg" alt="" />
        <router-link :to="{ name: path }" :class="{'disabled': path.includes('Multi-Game Plans')}">{{
          path.includes("Summary") ? "Summary" : path
        }}</router-link>
      </template>
    </div>
    <button class="view-chart" @click="showMap = true">
      <img src="@/assets/icons/stadium.svg" alt="" />
      <span>View Seating Chart</span>
    </button>
    <ChatButton />
  </header>
  <SeatingChart v-show="showMap" @close="showMap=false"/>
</template>
<script>
import ChatButton from "@/components/ChatButton";
import SeatingChart from "@/components/SeatingChart";
export default {
  name: "TopBar",
  data: () => ({
    breadcrumbs: [],
    showMap:false
  }),
  components: {
    ChatButton,
    SeatingChart
  },
  watch: {
    "$store.state.plans"() {
      this.getBreadCrumbs(); //this is set after dynamic routes are created
    },
    "$route.fullPath"() {
      this.$store.commit("setActivePlan", "");
      this.getBreadCrumbs(); //this watches for url changes
    },
  },
  mounted() {
    this.getBreadCrumbs(); //this sets breadcrumbs initially before dynamic routes are added for early routes
  },
  methods: {
    getBreadCrumbs() {
      let routes = this.$route.fullPath.split("/");
      routes.shift();
      let breadcrumbs = [];
      while (routes.length > 0) {
        const resolveRoute = routes.join("/");
        const routeName = this.$router.resolve(`/${resolveRoute}`).name;
        if (
          ["Stadium Pass", "Blue Mini-Plan", "Silver Mini-Plan"].includes(
            routeName
          )
        ) {
          routes.pop();
          continue;
        }
        if (routeName) {
          breadcrumbs.push(routeName);
        }
        routes.pop();
      }
      breadcrumbs = breadcrumbs.reverse();
      if (breadcrumbs[0] === "Home") {
        breadcrumbs = [];
      }
      this.breadcrumbs = breadcrumbs;
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background:none;
  border: none;
}
.view-chart {
  font-family: "United Sans Cd Bd";
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  text-align: right;
  @media (min-width:1000px) {
    text-align: center;
  }
  img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    margin-top:1px;
  }  
}
header {
  padding: 0;
  margin: 0;
  padding: 8px;
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  @media (min-width:500px) {
    padding: 0 0 0 80px;
  }
}
.breadcrumbs {
  flex-grow: 1;
  color: #ffffff;
  text-transform: uppercase;
  font-family: "United Sans Cd Bd";
  font-weight: bold;
  letter-spacing: 0.04em;
  font-size: 1rem;
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
a {
  position: relative;
  color:inherit;
  &:after {
    content: "";
    height: 1px;
    width: 0%;
    background: #fff;
    position: absolute;
    bottom: -3px;
    left: 0;
    pointer-events: none;
    transition: width 0.5s;
  }
  &.disabled {
    pointer-events: none !important;
    opacity: 0.75 !important;
  }
}
.router-link-active {
  opacity: 0.75;
  pointer-events: none;
}
a:only-child {
  opacity: 1;
}
a:not(.router-link-active) {
  &:hover:after {
    width: 100%;
  }
}
@media (max-width:400px) {
  .hide-on-mobile {
    display:none;
  }
}
</style>